export default {
  请选择您购入的产品: "Veuillez sélectionner le produit que vous avez acheté",
  产品选择: "Choix du produit",
  上一步: "Précédent",
  问题选择: "Sélection des problèmes",
  提示: "Malheureusement, aucun cas correspondant n'a été trouvé",
  找不到: "Aucun problème correspondant trouvé?",
  联系方式: "Cliquez ici pour nous contacter ›",
  点击这里: "Cliquez ici ›",
  提示2:
    "Merci de votre coopération, nous n'avons besoin que de la dernière étape pour recevoir votre demande ! Vous pouvez renvoyer la capture d'écran de la page à notre service client via les coordonnées suivantes, afin que nous puissions traiter votre demande dans les plus brefs délais",
  联系我们: "Contactez-nous",
  提示标题: "Conseils",
  支持: "Tineco Soutien",
};
